const MonthDayYear: DateFormat = {
  dashed: 'M-D-YYYY',
  fullDashed: 'MM-DD-YYYY',
  slashed: 'M/D/YYYY',
  fullSlashed: 'MM/DD/YYYY',
  long: 'MMM D, YYYY',
  longer: 'MMMM D, YYYY',
};

const DayMonthYear: DateFormat = {
  dashed: 'D-M-YYYY',
  fullDashed: 'DD-MM-YYYY',
  slashed: 'D/M/YYYY',
  fullSlashed: 'DD/MM/YYYY',
  long: 'D MMM YYYY',
  longer: 'D MMMM YYYY',
};

const YearMonthDay: DateFormat = {
  dashed: 'YYYY-M-D',
  fullDashed: 'YYYY-MM-DD',
  slashed: 'YYYY/M/D',
  fullSlashed: 'YYYY/MM/DD',
  long: 'YYYY MMM D',
  longer: 'YYYY MMMM D',
};

export const DateFormats: DateFormatMap = {
  '1': MonthDayYear,
  '2': DayMonthYear,
  '3': YearMonthDay,
} as const;

const Hour12: TimeFormat = {
  hour: 'ha',
  hourMinute: 'h:mm a',
};

const Hour24: TimeFormat = {
  hour: 'HH:00',
  hourMinute: 'H:mm',
};

export const TimeFormats: TimeFormatMap = {
  '1': Hour12,
  '2': Hour24,
} as const;
